<div [ngStyle]="{ margin }">
  @if (text && text.length) {
    <span>{{ text }}</span>
  }
  <div class="line" [ngStyle]="{ height }"></div>
</div>
